import React, { useMemo } from 'react'
import styles from "./TextBox.module.css"


const TextBox = ({ children, mode = "tip" }) => {

    const MODE_ICONS = useMemo(() => {
        return {
            "tip": "💡",
            "warning": "⚠"
        }
    }, []);

    const combinedClasses = `${styles.textBox} ${styles[mode] || ''}`;

    return (
        <div className={combinedClasses}>
            <span className={styles.boxIcon}>{MODE_ICONS[mode]}</span>
            <div className={styles.content}>
                {children}
            </div>
        </div >
    );
};

export default TextBox